import type { JSX, SVGProps } from 'react';
export default function SvgDropdown(props: SVGProps<SVGSVGElement>): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
            <path d="M8.25 9.75L12 6L15.75 9.75" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.25 14.25L12 18L15.75 14.25" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
